export const SUMMARY_CONTENTS = {
  salesAmount: { name: "チケットの売上金額", unit: "円" },
  salesCount: { name: "チケットの売上枚数", unit: "枚" },
} as const;
